var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnsureDifferent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 0.53125C0.765625 0.53125 0 1.32422 0 2.28125V11.0312C0 12.0156 0.765625 12.7812 1.75 12.7812H10.5C11.457 12.7812 12.25 12.0156 12.25 11.0312V2.28125C12.25 1.32422 11.457 0.53125 10.5 0.53125H1.75ZM3.125 3.5C3.125 3.23438 2.89062 3 2.625 3C2.34375 3 2.125 3.23438 2.125 3.5V7.5C2.125 7.78125 2.34375 8 2.625 8C2.89062 8 3.125 7.78125 3.125 7.5V3.5ZM2.625 10C2.96875 10 3.25 9.73438 3.25 9.375C3.25 9.03125 2.96875 8.75 2.625 8.75C2.26562 8.75 2 9.03125 2 9.375C2 9.73438 2.26562 10 2.625 10ZM5.35216 4.5C5.09255 4.5 4.89062 4.71635 4.89062 4.96154C4.89062 5.22115 5.09255 5.42308 5.35216 5.42308H10.4291C10.6743 5.42308 10.8906 5.22115 10.8906 4.96154C10.8906 4.71635 10.6743 4.5 10.4291 4.5H5.35216ZM5.35216 7.26923C5.09255 7.26923 4.89062 7.48558 4.89062 7.73077C4.89062 7.99038 5.09255 8.19231 5.35216 8.19231H10.4291C10.6743 8.19231 10.8906 7.99038 10.8906 7.73077C10.8906 7.48558 10.6743 7.26923 10.4291 7.26923H5.35216Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnsureDifferent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ensure_different.fdb79a7af1d631c0875d5da5eb0c2701.svg";